module.exports = __webpack_public_path__ + "static/media/sbtrkt.e0d87f53.jpg";